const { apiConfig } = window['runtimeConfig'];

export default {
  baseUrl: apiConfig.baseUrl
};
